// Ranks
export const contactMessageObjectChoiceArray = ['ReportABug', 'MakeAReturn', 'SuggestAnIdea'];
